import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=23435f84"
import script from "./imgs.vue?vue&type=script&lang=js"
export * from "./imgs.vue?vue&type=script&lang=js"
import style0 from "./imgs.vue?vue&type=style&index=0&id=23435f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports